import * as Sentry from '@sentry/react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthLayout } from './layouts/AuthLayout';
import { DashboardLayout } from './layouts/DashboardLayout';
import { ApplicationWizardPage } from './pages/application/ApplicationWizardPage';
import { BasicInfoPage } from './pages/auth/BasicInfoPage';
import { EmailVerificationPage } from './pages/auth/EmailVerificationPage';
import { ForgotPasswordPage } from './pages/auth/ForgotPasswordPage';
import { LoginPage } from './pages/auth/LoginPage';
import { RegisterPage } from './pages/auth/RegisterPage';
import { DashboardPage } from './pages/dashboard/DashboardPage';
import { AdmissionStatusPage } from './pages/enrollment/AdmissionStatusPage';
import { EnrollmentPage } from './pages/enrollment/EnrollmentPage';
import { CommonTestDataPage } from './pages/settings/CommonTestDataPage';
import { DocumentsPage } from './pages/settings/DocumentsPage';
import { ProfilePage } from './pages/settings/ProfilePage';

import './lib/i18n';

function App() {
  return (
    <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route element={<AuthLayout />}>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/email-verification" element={<EmailVerificationPage />} />
            <Route path="/basic-info" element={<BasicInfoPage />} />
          </Route>

          {/* Standalone Public Pages */}
          <Route path="/status-inquiry" element={<AdmissionStatusPage />} />

          {/* Protected Routes (Dashboard) */}
          {/* Note: In real app, these would be protected by auth guard */}
          <Route element={<DashboardLayout />}>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/application/new" element={<ApplicationWizardPage />} />

            <Route path="/enrollment" element={<EnrollmentPage />} />

            {/* Settings & Data */}
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/common-test" element={<CommonTestDataPage />} />
            <Route path="/documents" element={<DocumentsPage />} />
          </Route>

          {/* Redirect root to login for now */}
          <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  );
}

export default App;
